import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../../../components/atoms/Icon';
import Header from '../Header';
import styles from './Layout.module.scss';
import { analyticsClient } from '@spotted-zebra-uk/ui-components';
import { HEAP_ANALYTICS_EVENTS } from '@/constants/analytics';

interface LayoutProps {
  children: React.ReactNode;
  companyLogoUrl?: string;
  /** Where the back link exits to; defaults to the parent route. */
  backUrl?: string;
}

export function Layout({ children, companyLogoUrl, backUrl }: LayoutProps) {
  return (
    <main className={styles.layout}>
      <Header companyLogoUrl={companyLogoUrl} />
      <BackLink backUrl={backUrl} />
      {children}
    </main>
  );
}

function BackLink({ backUrl }: { backUrl?: string }) {
  const { t } = useTranslation();
  const location = useLocation();

  if (location.pathname === '/ai-interview-flow-0') {
    return null;
  }

  function handleBackButtonClick() {
    analyticsClient.trackEvent({
      name: HEAP_ANALYTICS_EVENTS.CANDIDATE_AI_INTERVIEW_BACK_LINK_CLICK
    })
  }

  return (
    <Link
      to={backUrl ?? '..'}
      className={styles.backLink}
      onClick={handleBackButtonClick}
    >
      <Icon icon="left_arrow" className={styles.backArrowIcon} />
      {t('stage.assessmentList')}
    </Link>
  );
}
